export const defaultBodyLoaderConfig = {
    innerTemplate: '<span class="w-full h-full flex-xyc absolute z-1"><img class="max-w-22" src="{{imageSrc}}" /></span>'
}